/**
 * Entry-point фронта — общий для всех инстансов.
 *
 * Vite запускается из директории инстанса, но root указывает сюда (в платформу).
 * Список клиентских bootstrap-ов берётся из virtual-модуля `virtual:ayo-config`,
 * который Vite-плагин `ayo-config-plugin` резолвит на `<cwd>/ayo.client.ts`
 * текущего инстанса.
 *
 * Этот файл не должен правиться разработчиком инстанса — это часть платформы.
 * Кастомизация делается через AppRuntime API внутри bootstrap-функций модулей.
 */
import ReactDOM from 'react-dom/client';
import { initOpenReplay } from '@ayocore/platform/client/utils/openreplay';
import AppRuntime from '@ayocore/platform/client/runtime/AppRuntime';
import { ensureServiceWorkerRegistration } from '@ayocore/platform/client/pwa/registerServiceWorker';

import './styles/mantine-bundle.css';

import appConfig from 'virtual:ayo-config';

initOpenReplay();
void ensureServiceWorkerRegistration();

await AppRuntime.getInstance().init(appConfig.modules);

// App импортируется ПОСЛЕ инициализации рантайма — Router внутри App
// должен видеть готовый AppRuntime.getRouteConfig().
const { default: App } = await import('./App');

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(<App />);
} else {
  // eslint-disable-next-line no-console
  console.error('No root div');
}
